import { createSuspenseComponent } from 'src/utils/suspense-companion/createSuspenseComponent';
import component from './PropertyOwners';
import { PropertyOwners } from './types';
import hook from './usePropertyOwners';

export default createSuspenseComponent({
  component: component as PropertyOwners,
  hook,
});
